import { Injectable } from '@angular/core';
declare var FB: any;

@Injectable({
  providedIn: 'root'
})
export class FacebookService {

  constructor() {
    this.loadFacebookSDK();
  }
  private loadFacebookSDK(): void {
    window["fbAsyncInit"] = () => {
      FB.init({
        appId      : '795161229229441',
        cookie     : true,
        xfbml      : true,
        version    : 'v19.0'
      });
    };

    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    console.log('Facebook SDK loaded')
  }

  login(): Promise<any> {
    return new Promise((resolve, reject) => {
      FB.login(response => {
        if (response.authResponse) {
          console.log('Authorization granted.');
          resolve(response);
        } else {
          reject('User cancelled login or did not fully authorize.');
        }
      }, {scope: 'email,public_profile,pages_show_list,pages_manage_posts'});
    });
  }

  loginUser(): Promise<string> {
    return new Promise((resolve, reject) => {
      FB.login(response => {
        if (response.authResponse) {
          console.log('Authorization granted.', response);
          resolve(response.authResponse.accessToken);
        } else {
          reject('User cancelled login or did not fully authorize.');
        }
      }, {scope: 'email,public_profile,pages_show_list,pages_manage_posts'});
    });
  }

  getAccessToken(): string {
    return FB.getAuthResponse()?.accessToken;
  }

  getPageAccessToken(userId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      FB.api(`/${userId}/accounts`, (response) => {
        if (response && !response.error) {
          console.log('Fetched page access tokens.');
          resolve(response.data);
        } else {
          reject(response.error);
        }
      });
    });
  }

  share(url: string): void {
    FB.ui({
      method: 'share',
      href: url,
    }, function(response){
      if (response && !response.error_message) {
        console.log('Content shared successfully');
      } else {
        console.error('Error while sharing content', response);
      }
    });
  }

  feed(link: string): void {
    FB.ui({
      method: 'feed',
      link: link,
    }, function(response){
      if (response && !response.error_message) {
        console.log('Post was published.');
      } else {
        console.error('Post was not published.', response);
      }
    });
  }

  feed2(link: string, caption: string, description: string, picture: string): void {
    FB.ui({
      method: 'feed',
      link: link,
      caption: caption,
      description: description,
      picture: picture
    }, function(response){
      if (response && !response.error_message) {
        console.log('Post was published.');
      } else {
        console.error('Post was not published.', response);
      }
    });
  }

}
